export const priceCalculationQueryKeyPrefix = 'getNewPrice';
